/**************
 Mobile Nav
 ***************/

// open slider search
document.querySelectorAll('.headerMobileSearch').forEach(el => {
    el.addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active');
            document.querySelector('.sliderSearch').classList.remove('active');
            return;
        }
        this.classList.add('active');
        document.querySelector('.sliderSearch').classList.add('active');
        openNav();
    })
})

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});


// setup Dropdowns
document.querySelectorAll(".headerNavLinkContentExpandedLinksDropdownTop")?.forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));